import { EmployeeFormFields } from 'src/components/enterprise/features/Employee/components/Form/types/EmployeeForm';

export function transformDepartmentUIToModel(
  values: Partial<EmployeeFormFields>
): Partial<EmployeeFormFields> {
  const { departmentId, ...rest } = values;

  // Only include departmentId if it has a value
  if (departmentId) {
    return values;
  }

  return rest;
}
